(function () {
  var root = document.querySelector("[data-b1p]");
  if (!root) return;

  var handle = root.getAttribute("data-handle");
  var catalogUrl = root.getAttribute("data-catalog-url");
  var customerId = root.getAttribute("data-customer-id") || "";

  var SLOT_CATEGORY = {
    strut: "Chassis & Bracing",
    coilover: "Suspension",
    arm: "Suspension",
    mirrors: "Exterior",
    shifter: "Interior",
    paddles: "Interior"
  };

  var UPGRADE_SLOTS = [
    { slot: "strut", name: "Chassis Bracing" },
    { slot: "coilover", name: "Coilovers" },
    { slot: "arm", name: "Suspension Arms" }
  ];

  var SPEC_FIELDS = {
    "Chassis Bracing": [
      ["part_code", "Part code"],
      ["position", "Position"],
      ["material", "Material"],
      ["color", "Color"],
      ["included_hardware", "Included hardware"],
      ["mpn", "Manufacturer part number"]
    ],
    "Coilovers": [
      ["coilover_series", "Series"],
      ["mpn", "Manufacturer part number"],
      ["front_spring_rate", "Front spring rate"],
      ["rear_spring_rate", "Rear spring rate"],
      ["damping_adjustment", "Damping adjustment"],
      ["height_adjustment", "Height adjustment"],
      ["front_configuration", "Front configuration"],
      ["rear_configuration", "Rear configuration"]
    ],
    "Suspension Arms": [
      ["arm_type", "Arm type"],
      ["mpn", "Manufacturer part number"],
      ["position", "Position"],
      ["adjustment_type", "Adjustment type"]
    ]
  };

  function profileKey() {
    return customerId ? "brace1-garage-profile-v1-" + customerId : "brace1-garage-profile-v1";
  }

  function readProfile() {
    try {
      return JSON.parse(localStorage.getItem(profileKey()) || "{}");
    } catch (err) {
      return {};
    }
  }

  function savedVehicle(profile) {
    if (profile.lastVehicle && profile.lastVehicle.make && profile.lastVehicle.model) {
      return profile.lastVehicle;
    }
    var builds = Object.values(profile.vehicleBuilds || {});
    if (!builds.length) return null;
    var latest = builds[builds.length - 1];
    if (latest && latest.make && latest.model) return latest;
    return null;
  }

  function vehicleLabel(vehicle) {
    if (!vehicle) return "";
    return [vehicle.year, vehicle.make, vehicle.model].filter(Boolean).join(" ");
  }

  function partFits(part, vehicle) {
    if (!part || !part.vehicles || !vehicle || !vehicle.make || !vehicle.model) return false;
    var year = Number(vehicle.year);
    return part.vehicles.some(function (row) {
      if (row.make !== vehicle.make || row.model !== vehicle.model) return false;
      if (!year) return true;
      return year >= row.yearStart && year <= row.yearEnd;
    });
  }

  function show(el) {
    if (el) el.hidden = false;
  }

  function readData() {
    var node = document.getElementById("B1pData-" + root.getAttribute("data-section-id"));
    if (!node) return {};
    try {
      var parsed = JSON.parse(node.textContent || "{}");
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch (err) {
      return {};
    }
  }

  function cleanValue(value) {
    var text = String(value == null ? "" : value).replace(/\s+/g, " ").trim();
    if (!text) return "";
    if (/^(n\/a|na|unknown|tbd|none|not available|specify actual material)$/i.test(text)) return "";
    return text;
  }

  function resolvedCategory(data, part) {
    var structured = cleanValue(data.category);
    if (structured) return structured;
    if (part && SLOT_CATEGORY[part.slot]) return SLOT_CATEGORY[part.slot];
    return cleanValue(data.productType);
  }

  function flattenThumbs() {
    var row = root.querySelector("[data-b1p-thumb-row]");
    if (!row || !window.jQuery) return;
    try {
      var $row = window.jQuery(row);
      if ($row.hasClass("slick-initialized")) $row.slick("unslick");
    } catch (err) {}
  }

  function bindThumbs() {
    var scroller = root.querySelector("[data-b1p-thumb-row]");
    var prev = root.querySelector("[data-b1p-thumb-prev]");
    var next = root.querySelector("[data-b1p-thumb-next]");
    if (prev && scroller) {
      prev.addEventListener("click", function () {
        scroller.scrollBy({ left: -180, behavior: "smooth" });
      });
    }
    if (next && scroller) {
      next.addEventListener("click", function () {
        scroller.scrollBy({ left: 180, behavior: "smooth" });
      });
    }
  }

  function splitDescription() {
    var source = root.querySelector("[data-b1p-details]");
    if (!source) return;
    var map = {
      installation: root.querySelector('[data-b1p-acc="installation"] .b1p-acc__body'),
      shipping: root.querySelector('[data-b1p-acc="shipping"] .b1p-acc__body'),
      warranty: root.querySelector('[data-b1p-acc="warranty"] .b1p-acc__body')
    };
    var current = null;
    Array.prototype.slice.call(source.childNodes).forEach(function (node) {
      var text = (node.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
      var heading = node.nodeType === 1 && text.length > 0 && text.length < 80;
      if (heading) {
        if (text.indexOf("install") !== -1) current = "installation";
        else if (text.indexOf("shipping") !== -1) current = "shipping";
        else if (text.indexOf("disclaimer") !== -1 || text.indexOf("warranty") !== -1) current = "warranty";
        else if (text.indexOf("payment") !== -1) current = null;
        else current = null;
      }
      if (current && map[current]) map[current].appendChild(node);
    });
    ["installation", "warranty"].forEach(function (key) {
      var body = map[key];
      var item = root.querySelector('[data-b1p-acc="' + key + '"]');
      if (item && body && body.textContent.trim()) item.hidden = false;
    });
  }

  function benefitLines() {
    var fromMeta = [];
    var meta = document.getElementById("B1pBenefits-" + root.getAttribute("data-section-id"));
    if (meta) {
      try {
        var parsed = JSON.parse(meta.textContent || "null");
        if (Array.isArray(parsed)) fromMeta = parsed.map(String).filter(Boolean);
      } catch (err) {}
    }
    if (fromMeta.length) return fromMeta.slice(0, 3);
    var details = root.querySelector("[data-b1p-details]");
    if (!details) return [];
    var skip = /^(model|compatibility|material|finish|installation|package includes)\b/i;
    return Array.prototype.slice
      .call(details.querySelectorAll("li"))
      .map(function (li) {
        return li.textContent.replace(/\s+/g, " ").trim();
      })
      .map(function (text) {
        var label = text.split(":")[0].trim();
        if (/^\d{4}\b/.test(label)) return "";
        return skip.test(label) ? "" : label;
      })
      .filter(function (label) {
        return label && label.length > 2 && label.length < 42;
      })
      .slice(0, 3);
  }

  function paintPerformance(image) {
    var lines = benefitLines();
    var band = root.querySelector("[data-b1p-perf]");
    var list = root.querySelector("[data-b1p-perf-list]");
    if (!band || !list || !lines.length) return;
    list.innerHTML = lines
      .map(function (line, index) {
        return "<li><span>" + (index + 1) + "</span>" + escapeHtml(line) + "</li>";
      })
      .join("");
    if (image) {
      var visual = root.querySelector("[data-b1p-perf-visual]");
      if (visual) visual.style.backgroundImage = "linear-gradient(90deg, rgba(0,0,0,.55), rgba(0,0,0,.2)), url('" + image + "')";
    }
    show(band);
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  // Completeness only. These are the 20 pilot products that already have
  // brace1.category. They are not a brand preference and they are not the
  // only products that can be recommended.
  var STRUCTURED_CATEGORY = {
    "2019-2020-toyota-camry-strut-tower-brace": 1,
    "2018-2021-toyota-camry-strut-brace-b1-300rs": 1,
    "2015-lexus-rc350-strut-tower-bar": 1,
    "2018-honda-accord-strut-brace-aluminum-tower-bar-red": 1,
    "2018-honda-accord-brace-aluminum-black": 1,
    "2018-honda-accord-brace1-strut-brace-red": 1,
    "brace1-front-upper-strut-tower-bar-for-bmw-g20-g21-g28-red": 1,
    "2014-2018-infiniti-q50-3-7-front-upper-strut-tower-bar-brace-for-3-7l-only": 1,
    "front-upper-strut-bar-for-ford-mustang-2015-2023": 1,
    "bc-c-154-br-ra": 1,
    "bc-c-152-ds-da": 1,
    "bc-a-153-ds-da": 1,
    "bc-racing-br-series-coilovers-lexus-rc350-f-sport-rwd-2015-2024-gsc10": 1,
    "bc-a-05-br-rs": 1,
    "bc-i-117-rm-ma": 1,
    "whiteline-kta306": 1,
    "whiteline-kta260": 1,
    "truhart-th-h223-po": 1,
    "spl-parts-spl-rua-e9x": 1,
    "bmr-suspension-tca046": 1
  };

  var STRUCTURED_SPEC = {
    "2018-2021-toyota-camry-strut-brace-b1-300rs": 1,
    "2018-honda-accord-strut-brace-aluminum-tower-bar-red": 1,
    "2018-honda-accord-brace-aluminum-black": 1,
    "bc-c-154-br-ra": 1,
    "bc-c-152-ds-da": 1,
    "bc-a-153-ds-da": 1,
    "bc-racing-br-series-coilovers-lexus-rc350-f-sport-rwd-2015-2024-gsc10": 1,
    "bc-a-05-br-rs": 1,
    "bc-i-117-rm-ma": 1,
    "whiteline-kta306": 1,
    "whiteline-kta260": 1,
    "truhart-th-h223-po": 1,
    "spl-parts-spl-rua-e9x": 1,
    "bmr-suspension-tca046": 1
  };

  function isCopyListing(part) {
    var value = String(part && part.handle || "").toLowerCase();
    return /^copy-of-/.test(value) || /^copy-/.test(value) || /-copy(?:-\d+)?$/.test(value);
  }

  function catalogRank(part) {
    var name = String(part.name || "").replace(/\s+/g, " ").trim();
    return [
      part.available === false ? 0 : 1,
      isCopyListing(part) ? 0 : 1,
      STRUCTURED_CATEGORY[part.handle] ? 1 : 0,
      STRUCTURED_SPEC[part.handle] ? 1 : 0,
      part.image ? 1 : 0,
      part.price ? 1 : 0,
      name.length > 12 ? 1 : 0
    ];
  }

  function sameCatalogRank(a, b) {
    var left = catalogRank(a);
    var right = catalogRank(b);
    for (var i = 0; i < left.length; i++) {
      if (left[i] !== right[i]) return false;
    }
    return true;
  }

  function liveRank(part) {
    var facts = part.storefront;
    if (!facts) return [1, part.available === false ? 0 : 1, 1, 1];
    return [
      facts.active ? 1 : 0,
      facts.available ? 1 : 0,
      facts.vendor ? 1 : 0,
      facts.sku ? 1 : 0
    ];
  }

  function loadStorefront(part) {
    if (part.storefront) return Promise.resolve(part);
    return fetch("/products/" + part.handle + ".js", { credentials: "same-origin" })
      .then(function (res) {
        if (res.status === 404) {
          part.storefront = { active: false, available: false, vendor: "", sku: false };
          return part;
        }
        if (!res.ok) return part;
        return res.json().then(function (product) {
          var variants = product.variants || [];
          part.storefront = {
            active: true,
            available: product.available === true,
            vendor: String(product.vendor || "").trim(),
            sku: variants.some(function (variant) {
              return String(variant.sku || "").trim();
            })
          };
          return part;
        });
      })
      .catch(function () {
        return part;
      });
  }

  function compatiblePool(parts, vehicle, slot) {
    return parts.filter(function (part) {
      if (!part || String(part.slot || "").toLowerCase() !== slot) return false;
      if (part.handle === handle) return false;
      return partFits(part, vehicle);
    }).sort(function (a, b) {
      var left = catalogRank(a);
      var right = catalogRank(b);
      for (var i = 0; i < left.length; i++) {
        if (left[i] !== right[i]) return right[i] - left[i];
      }
      return 0;
    });
  }

  function pickLive(pool, index, fallback) {
    if (index >= pool.length) return Promise.resolve(fallback);
    var group = [pool[index]];
    var next = index + 1;
    while (next < pool.length && group.length < 8 && sameCatalogRank(pool[index], pool[next])) {
      group.push(pool[next]);
      next += 1;
    }
    return Promise.all(group.map(loadStorefront)).then(function (loaded) {
      loaded.sort(function (a, b) {
        var left = liveRank(a);
        var right = liveRank(b);
        for (var i = 0; i < left.length; i++) {
          if (left[i] !== right[i]) return right[i] - left[i];
        }
        return 0;
      });
      var soldOut = fallback;
      for (var n = 0; n < loaded.length; n++) {
        var facts = loaded[n].storefront;
        if (facts && facts.active === false) continue;
        if (!facts) {
          if (loaded[n].available !== false) return loaded[n];
          if (!soldOut) soldOut = loaded[n];
          continue;
        }
        if (facts.available) return loaded[n];
        if (!soldOut) soldOut = loaded[n];
      }
      return pickLive(pool, next, soldOut);
    });
  }

  function chooseUpgrade(parts, vehicle, slot) {
    if (!vehicle) return Promise.resolve(null);
    return pickLive(compatiblePool(parts, vehicle, slot), 0, null);
  }

  function money(value) {
    var amount = Number(value);
    if (!Number.isFinite(amount) || amount <= 0) return "";
    return amount.toLocaleString("en-US", { style: "currency", currency: "USD" });
  }

  function upgradeCard(part, categoryName, soldOut) {
    var vendor = cleanValue((part.storefront && part.storefront.vendor) || part.vendor || "");
    var photo = part.image ? '<img src="' + escapeHtml(part.image) + '" alt="">' : "";
    var href = part.url || "";
    var title = cleanValue(part.name) || categoryName;
    var price = money(part.price);
    var cls = "b1p-cat is-open" + (soldOut ? " is-soldout" : "");
    return (
      '<a class="' + cls + '" href="' + escapeHtml(href) + '">' +
        '<div class="b1p-cat__photo">' + photo + "</div>" +
        '<div class="b1p-cat__body">' +
          (vendor ? '<p class="b1p-cat__vendor">' + escapeHtml(vendor) + "</p>" : "") +
          '<p class="b1p-cat__name">' + escapeHtml(categoryName) + "</p>" +
          '<p class="b1p-cat__title">' + escapeHtml(title) + "</p>" +
          (price ? '<p class="b1p-cat__price">' + escapeHtml(price) + "</p>" : "") +
          '<p class="b1p-cat__fit">Confirmed fit</p>' +
          (soldOut ? '<p class="b1p-cat__status">Sold out</p>' : "") +
        "</div>" +
      "</a>"
    );
  }

  function paintUpgradeCards(row, section, cards) {
    if (!cards.length) {
      row.innerHTML = "";
      row.removeAttribute("data-count");
      section.hidden = true;
      return;
    }
    row.innerHTML = cards.join("");
    row.setAttribute("data-count", cards.length > 4 ? "many" : String(cards.length));
    show(section);
  }

  function paintUpgrades(parts, vehicle, current) {
    var row = root.querySelector("[data-b1p-next-row]");
    var section = root.querySelector("[data-b1p-next]");
    var title = root.querySelector("[data-b1p-next-title]");
    if (!row || !section) return;
    var currentSlot = current ? String(current.slot || "").toLowerCase() : "";
    if (title) {
      title.textContent = vehicle && vehicle.model
        ? "Next upgrades for your " + vehicle.model
        : "Next upgrades";
    }
    if (!vehicle) {
      row.removeAttribute("data-count");
      row.innerHTML = '<p class="b1p-next__note">Select your car to see compatible upgrades.</p>';
      show(section);
      return;
    }
    var slots = UPGRADE_SLOTS.filter(function (cat) {
      return cat.slot !== currentSlot;
    });
    Promise.all(slots.map(function (cat) {
      return chooseUpgrade(parts, vehicle, cat.slot).then(function (sample) {
        return { cat: cat, sample: sample };
      });
    })).then(function (results) {
      var cards = [];
      results.forEach(function (result) {
        if (!result.sample) return;
        var soldOut = result.sample.storefront
          ? result.sample.storefront.available === false
          : result.sample.available === false;
        cards.push(upgradeCard(result.sample, result.cat.name, soldOut));
      });
      paintUpgradeCards(row, section, cards);
    }).catch(function () {
      paintUpgradeCards(row, section, []);
    });
  }

  function vehicleLine(row) {
    var years = row.yearStart && row.yearEnd ? " " + row.yearStart + "–" + row.yearEnd : "";
    return ((row.make || "") + " " + (row.model || "")).trim() + years;
  }

  function paintVehicles(part, fits) {
    var list = root.querySelector("[data-b1p-vehicles]");
    var card = root.querySelector("[data-b1p-fitcard]");
    var more = root.querySelector("[data-b1p-vehicles-more]");
    var vehicles = (part && part.vehicles) || [];
    if (!list || !card || !vehicles.length) return;
    list.innerHTML = vehicles.map(function (row, index) {
      return "<li" + (index >= 3 ? " hidden" : "") + ">" + escapeHtml(vehicleLine(row)) + "</li>";
    }).join("");
    if (more && vehicles.length > 3) {
      more.hidden = false;
      more.textContent = "View all compatible vehicles";
      more.onclick = function () {
        Array.prototype.forEach.call(list.children, function (item) {
          item.hidden = false;
        });
        more.hidden = true;
      };
    }
    if (fits) show(root.querySelector("[data-b1p-fit-confirmed]"));
    show(card);
    var fitCopy = root.querySelector("[data-b1p-fit-copy]");
    var fitAcc = root.querySelector('[data-b1p-acc="fitment"]');
    if (fitCopy) {
      fitCopy.innerHTML = "<ul>" + vehicles.map(function (row) {
        return "<li>" + escapeHtml(vehicleLine(row)) + "</li>";
      }).join("") + "</ul>";
      show(fitAcc);
    }
  }

  function paintSpecs(data) {
    var card = root.querySelector("[data-b1p-specs]");
    var list = root.querySelector("[data-b1p-spec-list]");
    if (!card || !list) return;
    var values = {};
    Object.keys(data || {}).forEach(function (key) {
      values[key] = cleanValue(data[key]);
    });
    values.mpn = cleanValue(data.sku);
    var fields = SPEC_FIELDS[cleanValue(data.category)] || [["mpn", "Manufacturer part number"]];
    var rows = fields.filter(function (field) {
      return values[field[0]];
    });
    if (!rows.length) return;
    list.innerHTML = rows.map(function (field) {
      return "<div><dt>" + escapeHtml(field[1]) + "</dt><dd>" + escapeHtml(values[field[0]]) + "</dd></div>";
    }).join("");
    show(card);
  }

  var buildRequest = null;
  var catalogParts = [];
  var currentPart = null;
  var vehicleSurfacesReady = false;
  var sheetVehicles = [];
  var sheetTrigger = null;

  function activeVehicle() {
    var api = window.BRACE1_GARAGE_API;
    if (api && typeof api.lastVehicle === "function") {
      var live = api.lastVehicle();
      if (live && live.make && live.model) return live;
    }
    return savedVehicle(readProfile());
  }

  function sameVehicle(a, b) {
    if (!a || !b) return false;
    return String(a.year || "") === String(b.year || "")
      && a.make === b.make
      && a.model === b.model
      && String(a.trim || "") === String(b.trim || "");
  }

  function listSavedVehicles() {
    var api = window.BRACE1_GARAGE_API;
    var rows = api && typeof api.savedVehicles === "function" ? api.savedVehicles() : [];
    if (!rows.length) {
      var profile = readProfile();
      rows = [];
      if (profile.lastVehicle) rows.push(profile.lastVehicle);
      Object.keys(profile.vehicleBuilds || {}).forEach(function (key) {
        rows.push(profile.vehicleBuilds[key]);
      });
    }
    return rows.filter(function (vehicle) {
      return vehicle && vehicle.make && vehicle.model;
    });
  }

  function garageUrl(vehicle) {
    if (!vehicle || !vehicle.make || !vehicle.model) return "/pages/garage";
    var params = new URLSearchParams();
    if (vehicle.year) params.set("year", String(vehicle.year));
    params.set("make", vehicle.make);
    params.set("model", vehicle.model);
    if (vehicle.trim) params.set("trim", vehicle.trim);
    return "/pages/garage?" + params.toString();
  }

  function highlightProductCategory(card, api, part, data) {
    if (!card || !api || typeof api.categorize !== "function") return;
    var title = root.querySelector("h1");
    var categoryId = api.categorize({
      slot: part && part.slot,
      category: cleanValue(data && data.category),
      name: (part && (part.name || part.title)) || (title ? title.textContent : ""),
      title: title ? title.textContent : ""
    });
    Array.prototype.forEach.call(card.querySelectorAll("[data-ba-bc-cat]"), function (row) {
      row.classList.toggle("is-product-cat", Boolean(categoryId) && row.getAttribute("data-ba-bc-cat") === categoryId);
    });
  }

  function paintBuildCard() {
    if (!buildRequest) return;
    var part = buildRequest.part;
    var vehicle = buildRequest.vehicle;
    var data = buildRequest.data || {};
    var preview = root.querySelector("[data-b1p-build-preview]");
    var offer = root.querySelector("[data-b1p-build-offer]");
    var empty = root.querySelector("[data-b1p-build-empty]");
    var card = preview ? preview.querySelector("[data-ba-build-card]") : null;
    var api = window.BRACE1_BUILD_CARD;
    var garage = window.BRACE1_GARAGE_API;
    var hasVehicle = Boolean(vehicle && vehicle.make && vehicle.model);
    if (!hasVehicle) {
      if (preview) preview.hidden = true;
      if (offer) offer.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }
    if (!card || !api || typeof api.compute !== "function" || typeof api.apply !== "function" || !garage) return;
    var parts = typeof garage.garageParts === "function" ? garage.garageParts() : [];
    var groups = typeof garage.vehicleGroups === "function"
      ? garage.vehicleGroups().filter(function (group) { return !group.unassigned; })
      : [];
    var equipped = typeof garage.equippedKeys === "function" ? garage.equippedKeys() : [];
    var fitting = typeof api.fitsVehicle === "function"
      ? parts.filter(function (row) { return api.fitsVehicle(row, vehicle); })
      : [];
    api.apply(card, api.compute({
      allParts: parts,
      groups: groups,
      vehicleParts: fitting,
      vehicle: vehicle,
      equippedKeys: equipped,
      driverName: card.getAttribute("data-ba-driver-name") || "Driver",
      memberYear: card.getAttribute("data-ba-member-year") || "",
      customerId: card.getAttribute("data-ba-customer-id") || customerId,
      garagePath: "/pages/garage"
    }));
    highlightProductCategory(card, api, part, data);
    var fits = Boolean(part && partFits(part, vehicle));
    var copy = root.querySelector("[data-b1p-build-copy]");
    if (copy) {
      copy.textContent = fits
        ? "Add this part to your Build Card and keep track of your build as it grows."
        : "This part is not confirmed for your saved vehicle. Adding it to your Build Card does not mark it as a confirmed fit.";
    }
    var add = root.querySelector("[data-b1p-build-add]");
    if (add) add.href = garageUrl(vehicle);
    if (empty) empty.hidden = true;
    if (preview) preview.hidden = false;
    if (offer) offer.hidden = false;
  }

  function queueBuildCard(part, vehicle, data) {
    buildRequest = { part: part, vehicle: vehicle, data: data };
    paintBuildCard();
  }

  window.addEventListener("brace1:garage-changed", refreshVehicleSurfaces);

  function refreshVehicleSurfaces() {
    if (!vehicleSurfacesReady) return;
    var vehicle = activeVehicle();
    paintUpgrades(catalogParts, vehicle, currentPart);
    paintPart(currentPart, vehicle, readData());
  }

  function openVehicleSheet(trigger) {
    var sheet = root.querySelector("[data-b1p-vehicle-sheet]");
    var list = root.querySelector("[data-b1p-vehicle-list]");
    if (!sheet || !list) return;
    var current = activeVehicle();
    sheetVehicles = listSavedVehicles();
    if (!sheetVehicles.length && current) sheetVehicles = [current];
    list.innerHTML = sheetVehicles.map(function (vehicle, index) {
      var selected = sameVehicle(vehicle, current);
      return '<button type="button" class="b1p-vehicle' + (selected ? " is-current" : "") + '" data-b1p-vehicle-index="' + index + '">'
        + "<span>" + escapeHtml(vehicleLabel(vehicle)) + "</span>"
        + (selected ? '<span class="b1p-vehicle__mark">Selected</span>' : "")
        + "</button>";
    }).join("");
    sheetTrigger = trigger || null;
    if (typeof sheet.showModal === "function" && !sheet.open) sheet.showModal();
    var first = list.querySelector("button");
    if (first) first.focus();
  }

  function closeVehicleSheet() {
    var sheet = root.querySelector("[data-b1p-vehicle-sheet]");
    if (sheet && sheet.open && typeof sheet.close === "function") sheet.close();
  }

  function chooseVehicle(vehicle) {
    if (!vehicle) return;
    closeVehicleSheet();
    var api = window.BRACE1_GARAGE_API;
    if (api && typeof api.setActiveVehicle === "function") {
      api.setActiveVehicle(vehicle);
      return;
    }
    var profile = readProfile();
    profile.lastVehicle = {
      year: vehicle.year ? String(vehicle.year) : "",
      make: vehicle.make,
      model: vehicle.model,
      trim: vehicle.trim || "",
      engine: vehicle.engine || ""
    };
    try {
      localStorage.setItem(profileKey(), JSON.stringify(profile));
    } catch (err) {}
    refreshVehicleSurfaces();
  }

  function bindVehicleSheet() {
    root.addEventListener("click", function (event) {
      var change = event.target.closest("[data-b1p-change-vehicle]");
      if (change) {
        event.preventDefault();
        openVehicleSheet(change);
        return;
      }
      var pick = event.target.closest("[data-b1p-vehicle-index]");
      if (pick) {
        chooseVehicle(sheetVehicles[Number(pick.getAttribute("data-b1p-vehicle-index"))]);
        return;
      }
      if (event.target.closest("[data-b1p-sheet-close]")) closeVehicleSheet();
    });
    var sheet = root.querySelector("[data-b1p-vehicle-sheet]");
    if (!sheet) return;
    sheet.addEventListener("click", function (event) {
      if (event.target === sheet) closeVehicleSheet();
    });
    sheet.addEventListener("close", function () {
      if (sheetTrigger && typeof sheetTrigger.focus === "function") sheetTrigger.focus();
    });
  }

  function paintPart(part, vehicle, data) {
    var fits = part && partFits(part, vehicle);
    var label = vehicleLabel(vehicle);
    var vendor = root.getAttribute("data-vendor") || "";
    var category = resolvedCategory(data, part);
    var eyebrow = root.querySelector("[data-b1p-eyebrow]");
    if (eyebrow && (cleanValue(data.category) || part)) {
      eyebrow.textContent = vendor && category ? vendor + " · " + category : (vendor || category);
    }
    var buildCategory = root.querySelector("[data-b1p-build-category]");
    if (buildCategory && cleanValue(data.category)) {
      buildCategory.textContent = cleanValue(data.category);
      show(buildCategory);
    }

    var fitsBox = root.querySelector("[data-b1p-fits]");
    var pending = root.querySelector("[data-b1p-fits-pending]");
    var pendingVehicle = root.querySelector("[data-b1p-fits-pending-vehicle]");
    var pendingCopy = root.querySelector("[data-b1p-fits-pending-copy]");
    if (fitsBox) fitsBox.hidden = true;
    if (pending) pending.hidden = true;
    if (fits && label) {
      var fitsVehicle = root.querySelector("[data-b1p-fits-vehicle]");
      if (fitsVehicle) fitsVehicle.textContent = label;
      show(fitsBox);
      var buildVehicle = root.querySelector("[data-b1p-build-vehicle]");
      if (buildVehicle) {
        buildVehicle.textContent = label;
        show(buildVehicle);
      }
    } else if (pending && label) {
      if (pendingVehicle) {
        pendingVehicle.textContent = label;
        show(pendingVehicle);
      }
      if (pendingCopy) pendingCopy.textContent = "This part isn't confirmed for your selected vehicle.";
      show(pending);
    } else if (pending) {
      if (pendingVehicle) pendingVehicle.hidden = true;
      if (pendingCopy) pendingCopy.textContent = "Select your car in the garage";
      show(pending);
    }

    if (part) paintVehicles(part, fits);
    paintSpecs(data);
    var extra = part && ((part.images && part.images[1]) || part.image || "");
    paintPerformance(extra);
    queueBuildCard(part, vehicle, data);
  }

  fetch(catalogUrl)
    .then(function (res) { return res.json(); })
    .then(function (data) {
      var parts = data.parts || [];
      var part = parts.filter(function (row) { return row.handle === handle; })[0] || null;
      catalogParts = parts;
      currentPart = part;
      var vehicle = activeVehicle();
      var record = readData();
      vehicleSurfacesReady = true;
      paintUpgrades(parts, vehicle, part);
      paintPart(part, vehicle, record);
    })
    .catch(function () {
      paintPart(null, activeVehicle(), readData());
    });

  function reviewBadgeVisible(box) {
    var badge = box.querySelector(".jdgm-prev-badge");
    if (!badge) return false;
    var style = window.getComputedStyle(badge);
    if (style.display === "none" || style.visibility === "hidden" || Number(style.opacity) === 0) return false;
    if (!badge.getClientRects().length) return false;
    var text = (badge.innerText || "").replace(/\s+/g, " ").trim();
    return text.length > 0;
  }

  function syncReviewBadge() {
    var box = root.querySelector(".b1p-reviews");
    if (!box) return;
    box.classList.toggle("is-visible", reviewBadgeVisible(box));
  }

  syncReviewBadge();
  var reviewBox = root.querySelector(".b1p-reviews");
  if (reviewBox && window.MutationObserver) {
    new MutationObserver(syncReviewBadge).observe(reviewBox, {
      attributes: true,
      childList: true,
      subtree: true
    });
  }
  window.setTimeout(syncReviewBadge, 600);
  window.setTimeout(syncReviewBadge, 2000);

  function frameProductPhoto(img) {
    if (!img || img.getAttribute("data-b1p-framed")) return;
    if (!img.naturalWidth || !img.naturalHeight) return;
    if (!window.CSS || !CSS.supports || !CSS.supports("object-view-box", "inset(0%)")) return;
    img.setAttribute("data-b1p-framed", "1");

    var scale = Math.min(1, 360 / Math.max(img.naturalWidth, img.naturalHeight));
    var w = Math.max(1, Math.round(img.naturalWidth * scale));
    var h = Math.max(1, Math.round(img.naturalHeight * scale));
    var canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    var ctx = canvas.getContext("2d", { willReadFrequently: true });
    var data;
    try {
      ctx.drawImage(img, 0, 0, w, h);
      data = ctx.getImageData(0, 0, w, h).data;
    } catch (err) {
      return;
    }

    var minX = w;
    var minY = h;
    var maxX = 0;
    var maxY = 0;
    var count = 0;
    var step = w > 240 ? 2 : 1;
    var y;
    var x;
    for (y = 0; y < h; y += step) {
      for (x = 0; x < w; x += step) {
        var i = (y * w + x) * 4;
        var red = data[i];
        var green = data[i + 1];
        var blue = data[i + 2];
        var alpha = data[i + 3];
        if (alpha < 20) continue;
        if (red > 242 && green > 242 && blue > 242) continue;
        count += 1;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
      }
    }
    if (!count) return;

    var contentW = (maxX - minX + 1) / w;
    var contentH = (maxY - minY + 1) / h;
    if (contentW > 0.64 && contentH > 0.64) return;
    if (contentW * contentH < 0.04) return;

    var marginX = Math.max(4, Math.round(w * 0.02));
    var marginY = Math.max(4, Math.round(h * 0.02));
    minX = Math.max(0, minX - marginX);
    minY = Math.max(0, minY - marginY);
    maxX = Math.min(w - 1, maxX + marginX);
    maxY = Math.min(h - 1, maxY + marginY);

    var top = (minY / h) * 100;
    var right = ((w - maxX - 1) / w) * 100;
    var bottom = ((h - maxY - 1) / h) * 100;
    var left = (minX / w) * 100;
    var viewW = ((maxX - minX + 1) / w) * img.naturalWidth;
    var viewH = ((maxY - minY + 1) / h) * img.naturalHeight;

    img.style.objectViewBox = "inset(" + top.toFixed(2) + "% " + right.toFixed(2) + "% " + bottom.toFixed(2) + "% " + left.toFixed(2) + "%)";
    img.style.aspectRatio = viewW.toFixed(2) + " / " + viewH.toFixed(2);
    img.style.width = "100%";
    img.style.height = "auto";
    img.style.maxHeight = "520px";
    img.style.objectFit = "contain";
  }

  function frameProductPhotos() {
    var images = root.querySelectorAll(".b1p-slide__img");
    Array.prototype.forEach.call(images, function (img) {
      if (img.complete && img.naturalWidth) frameProductPhoto(img);
      else img.addEventListener("load", function () { frameProductPhoto(img); });
    });
  }

  bindVehicleSheet();
  splitDescription();
  bindThumbs();
  window.setTimeout(flattenThumbs, 400);
})();
